import type { CSSProperties } from "react";
import type { CaseLabelSettings } from "@/cms/case-labels";

export function newCaseLabelStyle(settings?: CaseLabelSettings) {
  return ["solid", "transparent", "frosted"].includes(settings?.style ?? "");
}

export function caseLabelSurface(settings: CaseLabelSettings): CSSProperties {
  const background = `var(--label-bg-color, ${settings.bgColor || "#3C3C3B"})`;
  const opacity = settings.style === "frosted" ? 65 : 75;
  const frosted = settings.style === "frosted";
  return {
    color: `var(--label-text-color, ${settings.textColor || "#ffffff"})`,
    backgroundColor:
      settings.style === "solid"
        ? background
        : `color-mix(in srgb, ${background} ${opacity}%, transparent)`,
    ...(frosted
      ? {
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          border: "1px solid color-mix(in srgb, currentColor 20%, transparent)",
          boxShadow: "0 2px 12px rgb(0 0 0 / 8%)",
        }
      : {}),
  };
}
